import { render, staticRenderFns } from "./rent-custom-form.vue?vue&type=template&id=05481cfb&scoped=true"
import script from "./rent-custom-form.vue?vue&type=script&lang=js"
export * from "./rent-custom-form.vue?vue&type=script&lang=js"
import style0 from "./rent-custom-form.vue?vue&type=style&index=0&id=05481cfb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05481cfb",
  null
  
)

export default component.exports